<template>
  <!-- eslint-disable -->
  <div class="container ">
      <v-row>
        <div style="    margin-left: -35px;
    margin-top: 12px;">
            <v-btn to="/analytics/custom-report" icon><i class="las la-arrow-left"></i></v-btn>
        </div>
        <v-col class="col-11">
            <v-text-field
                style="max-width:40%"
                label="Name*"
                name="Report name"
                placeholder="Enter report name"
                outlined
                v-validate="'required|alpha_spaces|max:30'"
                :error-messages="errors.collect('Report name')"
                v-model="report.name"
                dense
            ></v-text-field>
        </v-col>
      </v-row>
    <v-tabs
    
      class="colomn-drag"
      v-model="tab"
      background-color="transparent"
      color="basil"
      grow
    >
      <v-tab
      style="max-width:25%; pointer-events: none;"
      :class="tab < 1 ? 'greyBorder' : 'greenBorder'"
      >
        <p class="w-100 text-left">
          1. Select source <br><small style="text-transform: none;">Selected source determines the key data <br>represented by each row of the report</small>
        </p>
      </v-tab>
      <v-tab
      :class="tab < 2 ? 'greyBorder' : 'greenBorder'"
      style="max-width:25%; pointer-events: none;"
      >
        <p class="w-100 text-left">
          2. Select columns <small style="text-transform: none;"><br>Selected columns represents the fields<br> present in the report</small>
        </p>
      </v-tab>
    <v-tab
    :class="tab < 3 ? 'greyBorder' : 'greenBorder'"
    style="max-width:25%; pointer-events: none;"
      >
        <p class="w-100 text-left">
          3. Select filters <small style="text-transform: none;"><br>Selected filters represents the data<br> present in the report</small>
        </p>
      </v-tab>
            <v-tab
            :class="tab < 4 ? 'greyBorder' : 'greenBorder'"
            style="max-width:25%; pointer-events: none;"
      >
        <p class="w-100 text-left">
          4. Schedule and generate report<br><small style="text-transform: none;">Get a detailed report as per filters<br> applied in the previous steps</small>
        </p>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" class="colomn-drag">
      <v-tab-item
      >
        <v-row class="">
            <v-col class="col-6" style="cursor:pointer" v-for="(cn, n) in columnName" :key="n">
              <div class="box-container  pa-5 text-center"  @click="moveToColumn(cn, n)">
              <v-img
                v-if="cn === 'UserProfile Data' || cn === 'User Profile Data'"
                src="../../assets/reports/user.png"
                height="75px"
                width="75px"
                class="text-center mx-auto"
              ></v-img>
              <v-img
                v-if="cn === 'Employees Overview Data'"
                src="../../assets/reports/employee-overview.png"
                height="75px"
                width="75px"
                class="text-center mx-auto"
              ></v-img>
              <v-img
                v-if="cn === 'Employee Chats Data'"
                src="../../assets/reports/chat-response.png"
                height="75px"
                width="75px"
                class="text-center mx-auto"
              ></v-img>
              <v-img
                v-if="cn === 'Employee Responses Data'"
                src="../../assets/reports/response.png"
                height="75px"
                width="75px"
                class="text-center mx-auto"
              ></v-img>
                <div class="">
                    {{cn}}
                </div>
              </div>
            </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item class="">
        <v-row v-if="allColumns" class="v-card ml-2 mr-2">
            <v-col class="col-8" style="">
              <div class=" pl-2" style=" max-height:400px; overflow-y:scroll; overflow-x:hidden; border:1px solid #dadce0;">
                <v-list
                v-for="(abc, i) in allColumns" :key="i"
                    nav
                    dense
                    style="border-bottom:1px solid #dadce0;"
                >
                    <v-list-item-group
                    color="primary"
                    >
                    <v-list-item style="height: 35px;">
                        <v-list-item-icon style="    margin-top: -12px;">
                            <v-checkbox
                        @change="updateColomn(abc, abc.selected, i)"
                        v-model="abc.selected"
                        :value="abc.selected"
                        ></v-checkbox>
                        </v-list-item-icon>

                        <v-list-item-content>
                        <v-list-item-title> 
                            <v-chip
                            class="ma-2"
                            color="#050550"
                            label
                            small
                            text-color="white"
                            >
                            {{abc.name}}
                            </v-chip>
                        </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    </v-list-item-group>
                </v-list>
                <!-- <v-text-field
                    dense
                    label="Search colomn..."
                    outlined
                ></v-text-field> -->
                <!-- <v-row style="height:60px;" c v-for="(abc, i) in allColumns" :key="i">
                    <v-col class="col-1">
                        <v-checkbox
                        @change="updateColomn(abc, abc.selected, i)"
                        v-model="abc.selected"
                        :value="abc.selected"
                        ></v-checkbox>
                    </v-col>
                    <v-col class="col-11" style="    align-self: center;">
                        {{abc.name}}
                    </v-col>
                </v-row> -->
              </div>
            </v-col>
            <v-col class="col-4 " style="max-height:400px; overflow-y:scroll;">
                <span v-if="enabledColumns">{{enabledColumns.length}}</span>/{{allColumns.length}}
                <Container group-name="1"
                    @drop="onDrop($event)"
                    :drag-end="onDragEnd"
                    drag-handle-selector=".handle"
                    style="border:1px solid #dadce0"
                    >
                    <Draggable v-for="(q, qi) in enabledColumns" :key="qi">
                        <v-list
                            nav
                            dense
                            style="border-bottom:1px solid #dadce0; border-radius:0"
                        >
                            <v-list-item-group
                            color="primary"
                            >
                            <v-list-item style="height: 35px;">
                                <v-list-item-icon>
                                    <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon color="grey" class="handle pl-3" v-bind="attrs" v-on="on">
                                        las la-arrows-alt
                                        </v-icon>
                                    </template>
                                        Move
                                    </v-tooltip>
                                </v-list-item-icon>

                                <v-list-item-content>
                                <v-list-item-title>{{qi+1}} 
                                    <v-chip
                                    class="ma-2"
                                    color="#050550"
                                    label
                                    small
                                    text-color="white"
                                    >
                                    {{q.name}}
                                    </v-chip>
                                </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </Draggable>
                </Container>
            </v-col>
        </v-row>
        
        <v-btn
        @click="tab = 2"
            style="float:right"
            class="ma-2"
            color="primary"
            > Next <v-icon class="pl-2">las la-chevron-right</v-icon>
        </v-btn>
        <v-btn
        @click="tab = 0"
            class="ma-2"
            ><v-icon class="pl-2">las la-chevron-left</v-icon> Previous
        </v-btn>
      </v-tab-item>
      <v-tab-item
      >
        <v-row class="v-card ml-2 mr-2">
            <v-col class="col-12" style="height:400px; overflow-y:auto; overflow-x:hidden;">
                <h5 style="font-size:18px;"><strong>Select data filters</strong></h5>
                <v-row v-for="(filter, fi) in filtersCount" :key="fi">
                  <v-col cols="1"><h5 class="mt-4 text-center" style="position:relative;top:1px"> <strong> {{fi+1}} </strong></h5> </v-col>
                  <v-col class="col-3">
                      <v-select
                        style="margin-top:10px; width:100%;"
                        :items="filterName"
                        v-model="report.filters[fi].name"
                        label="Filter name"
                        outlined
                        dense
                        @change="getSelectedFilterOption(report.filters[fi].name, fi)"
                        ></v-select>
                  </v-col>
                  <v-col class="col-4">
                      <v-select
                        v-if="report.filters[fi].type === 'options' || report.filters[fi].type === ''"
                        style="margin-top:10px; width:100%;"
                        :items="report.filters[fi].options"
                        v-model="report.filters[fi].value"
                        label="Filter options"
                        outlined
                        chips
                        multiple
                        dense
                        ></v-select>
                        <v-select
                        v-if="report.filters[fi].type === 'boolean'"
                        style="margin-top:10px; width:100%;"
                        :items="reportbooleanoptions"
                        v-model="report.filters[fi].value"
                        label="Filter options"
                        outlined
                        dense
                        ></v-select>
                        <v-menu
                          v-if="report.filters[fi].type === 'date'"
                          v-model="filterOptionDateMenu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                            style="margin-top: 15px;"
                              label="Select date"
                              outlined
                              dense
                              name="start date"
                              v-model="report.filters[fi].value"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="report.filters[fi].value" @input="filterOptionDateMenu = false">
                          </v-date-picker>
                        </v-menu>
                        <v-dialog
                          v-if="report.filters[fi].type === 'time'"
                          v-model="filterOptionDateMenu1"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          persistent
                          offset-y
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                            style="margin-top: 15px;"
                              label="Select time"
                              outlined
                              dense
                              name="start time"
                              v-model="report.filters[fi].value"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-time-picker  full-width v-model="report.filters[fi].value" >
                            <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="filterOptionDateMenu1 = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="filterOptionDateMenu1 = false"
          >
            OK
          </v-btn>
                          </v-time-picker>
                        </v-dialog>
                  </v-col>
                  <v-col v-if="filtersCount > 1" class="text-left" align-self="end" style="position:relative;top:-30px;max-width:50px;padding:0px">
                    <button class="btn btn-red btn-custom colored" @click="removeFilter(fi)">
                      <i class="las la-times" style="font-size:15px"></i>
                    </button>
                  </v-col>

                  <v-col cols="2" v-if="(fi+1) === filtersCount" class="text-left" align-self="end" style="position:relative;top:-30px;max-width:130px;padding:0px">
                    <button style="color:#050550" :disabled='!report.filters[fi].value && !report.filters[fi].name' @click="addFilter(report.filters[fi].value, report.filters[fi].name)" class="btn btn-blue btn-custom colored">
                      <i class="las la-plus" style="font-size:15px"></i>
                      Add filter
                    </button>
                  </v-col>
                </v-row>
            </v-col>
            
        </v-row>
        <v-btn
        @click="tab = 3"
            style="float:right"
            class="ma-2"
            color="primary"
            > Next <v-icon class="pl-2">las la-chevron-right</v-icon>
        </v-btn>
        <v-btn
        @click="tab = 1"
            class="ma-2"
            ><v-icon class="pl-2">las la-chevron-left</v-icon> Previous
        </v-btn>
      </v-tab-item>
      <v-tab-item
      >
      <div class="v-card" style="height:400px; overflow-y:auto; overflow-x:hidden;"> 
        <v-row class="ml-2 mr-2">
            <v-col>
                <h5 style="font-size:18px;"><strong>Schedule and share</strong></h5>
                <small>Choose a frequency for the report to be run and users who should have the access for the report.</small>
                <v-row>
                    <v-col class="col-4">
                        <v-select
                        style="margin-top:20px; width:100%;"
                        :items="items"
                        v-model="report.report_frequency"
                        label="Report Frequency"
                        outlined
                        dense
                        ></v-select>
                    </v-col>
                    <v-col class="col-4" v-if="report.report_frequency === 'Weekly'">
                        <v-select
                        style="margin-top:20px; width:100%;"
                        :items="weeklyItem"
                        v-model="report.trigger_day"
                        label="Day of week*"
                        name= "day of week"
                        v-validate="'required'"
                        :error-messages="errors.collect('day of week')"
                        outlined
                        dense
                        ></v-select>
                    </v-col>
                    <v-col class="col-4" v-if="report.report_frequency === 'Monthly'">
                        <v-select
                        style="margin-top:20px; width:100%;"
                        :items="monthlyItem"
                        v-model="report.trigger_day"
                        label="Day of month*"
                        name= "day of month"
                        v-validate="'required'"
                        :error-messages="errors.collect('day of month')"
                        outlined
                        dense
                        ></v-select>
                    </v-col>
                </v-row>
                
            </v-col>
        </v-row>
        <v-row class="ml-2 mr-2" v-if="report.report_frequency === 'Daily' || report.report_frequency === 'Monthly' || report.report_frequency === 'Weekly'" style="border-top:1px solid #dadce0;">
          <v-col class="col-4">
            Start date*
          </v-col>
          <v-col class="col-4">
            End date*
          </v-col>
        </v-row>
        <v-row class="ml-2 mr-2" v-if="report.report_frequency === 'Daily'">
            <v-col class="col-4">
                <v-menu
              v-model="filterDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="Select start date"
                  outlined
                  dense
                  v-validate="'required'"
                  :error-messages="errors.collect('start date')"
                  name="start date"
                  v-model="report.schedule_start_date"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="report.schedule_start_date" :min="minDate" @input="filterDateMenu = false">
              </v-date-picker>
            </v-menu>
            </v-col>
            <v-col class="col-4" style="padding-top:0;">
                <v-radio-group v-model="radioGroup" style="margin-top:0;    margin-top: 15px;   display: -webkit-box;">
                            <v-radio
                                label="Never"
                                style="    margin-right: 50px;; margin-bottom: 0;"
                                @change="changeRadio('never')"
                                value="startdate"
                            ></v-radio>
                            <v-radio
                                label="Custom"
                                @change="changeRadio('custom')"
                                value="customdate"
                            ></v-radio>
                </v-radio-group>
            </v-col>
            <v-col class="col-4" v-if="customDateShow">
                <v-menu
              v-model="customDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="Select end date"
                  outlined
                  dense
                  v-validate="'required'"
                  :error-messages="errors.collect('end date')"
                  name="end date"
                  start date
                  v-model="report.schedule_end_date"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="report.schedule_end_date" :min="report.schedule_start_date" @input="customDate = false">
              </v-date-picker>
            </v-menu>
            </v-col>
            <v-col class="col-12">
                <v-select
                    v-model="report.recipient_list"
                    :items="adminList"
                    chips
                    label="Report recipients"
                    multiple
                    outlined
                ></v-select>
            </v-col>
        </v-row>
        <v-row class="ml-2 mr-2" v-if="report.report_frequency === 'Weekly'">
            <v-col class="col-4">
                <v-menu
              v-model="filterDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="Select start date"
                  outlined
                  dense
                  v-validate="'required'"
                  :error-messages="errors.collect('start date')"
                  name="start date"
                  v-model="report.schedule_start_date"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="report.schedule_start_date" :min="minDate" @input="filterDateMenu = false">
              </v-date-picker>
            </v-menu>
            </v-col>
            <v-col class="col-4" style="padding-top:0;">
                <v-radio-group v-model="radioGroup" style="margin-top:0;">
                    <v-row>
                        <v-col class="col-6">
                            <v-radio
                                label="Never"
                                style="    margin-right: 50px;; margin-bottom: 0;"
                                @change="changeRadio('never')"
                            ></v-radio>
                        </v-col>
                        <v-col class="col-6">
                            <v-radio
                                label="Custom"
                                @change="changeRadio('custom')"
                            ></v-radio>
                        </v-col>
                    </v-row>
                </v-radio-group>
            </v-col>
            <v-col class="col-4" v-if="customDateShow">
                <v-menu
              v-model="customDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="Select end date"
                  v-validate="'required'"
                  :error-messages="errors.collect('end date')"
                  name="end date"
                  outlined
                  dense
                  v-model="report.schedule_end_date"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="report.schedule_end_date" :min="report.schedule_start_date" @input="customDate = false">
              </v-date-picker>
            </v-menu>
            </v-col>
            <v-col class="col-12">
                <v-select
                    v-model="report.recipient_list"
                    :items="adminList"
                    chips
                    label="Report recipients"
                    multiple
                    outlined
                ></v-select>
            </v-col>
        </v-row>
        <v-row class="ml-2 mr-2" v-if="report.report_frequency === 'Monthly'">
            <v-col class="col-4">
                <v-menu
              v-model="filterDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  placeholder="Select start date"
                  outlined
                  dense
                  v-validate="'required'"
                  :error-messages="errors.collect('start date')"
                  name="start date"
                  v-model="report.schedule_start_date"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="report.schedule_start_date" :min="minDate" @input="filterDateMenu = false">
              </v-date-picker>
            </v-menu>
            </v-col>
            <v-col class="col-4" style="padding-top:0;">
                <v-radio-group v-model="radioGroup" style="margin-top:0;">
                    <v-row>
                        <v-col class="col-6">
                            <v-radio
                                label="Never"
                                style="    margin-right: 50px;; margin-bottom: 0;"
                                @change="changeRadio('never')"
                            ></v-radio>
                        </v-col>
                        <v-col class="col-6">
                            <v-radio
                                label="Custom"
                                @change="changeRadio('custom')"
                            ></v-radio>
                        </v-col>
                        <p class="error--text ml-3" v-if="!dailyEndnever && !dailyEndCustom && showendDateerror"><small>End date is required</small></p>
                    </v-row>
                </v-radio-group>
            </v-col>
            <v-col class="col-4" v-if="customDateShow">
                <v-menu
              v-model="customDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  placeholder="Select end date"
                  outlined
                  dense
                  v-validate="'required'"
                  :error-messages="errors.collect('end date')"
                  name="end date"
                  v-model="report.schedule_end_date"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="report.schedule_end_date" :min="report.schedule_start_date" @input="customDate = false">
              </v-date-picker>
            </v-menu>
            </v-col>
            <v-col class="col-12">
                <v-select
                    v-model="report.recipient_list"
                    :items="adminList"
                    chips
                    label="Report recipients"
                    multiple
                    outlined
                ></v-select>
            </v-col>
        </v-row>
      </div>
    <v-btn
      v-if="$route.name !== 'EditCustomReport'"
      class="ma-2"
      @click="validateDetails()"
      style="float:right"
      
      color="primary"
    >
      <v-icon>las la-save</v-icon> Save report
    </v-btn>
    <v-btn
      v-if="$route.name !== 'EditCustomReport'"
      @click="saveAndDownload()"
      class="ma-2"
      style="float:right"
      
      color="primary"
    >
      <v-icon>las la-download</v-icon> Save and download report
    </v-btn>
    <v-btn
      v-if="$route.name === 'EditCustomReport'"
      class="ma-2"
      @click="validateUpdateDetails()"
      style="float:right"
      
      color="primary"
    >
      <v-icon>las la-save</v-icon> Update report
    </v-btn>
    <v-btn
      v-if="$route.name === 'EditCustomReport'"
      @click="updateAndDownload()"
      class="ma-2"
      style="float:right"
      
      color="primary"
    >
      <v-icon>las la-download</v-icon> Update and download report
    </v-btn>
    <v-btn
        @click="tab = 2"
            class="ma-2"
            ><v-icon class="pl-2">las la-chevron-left</v-icon> Previous
        </v-btn>
      </v-tab-item>

    </v-tabs-items>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import { mapState } from 'vuex';
import { Container, Draggable } from 'vue-smooth-dnd';
import dayjs from 'dayjs';

export default {
  name: 'DiversityReport',
  components: {
    // ContentLoader,
    // VCheckbox,
    // VAlert,
    // VAvatar,
    // VAutocomplete,
    // VTooltip,
    // VTextarea,
    // VProgressLinear,
    // VSlider,
    Container,
    Draggable,
  },
  data () {
    return {
      socketResponse: {
        show: false
      },
      radioGroup: null,
      filterOptionDateMenu: false,
      filterOptionDateMenu1: false,
      minDate: dayjs().format(),
      filterDateMenu: false,
      optionTypeTime: false,
      dailyEndnever: false,
      showendDateerror: false,
      dailyEndCustom: false,
      customDateShow: false,
      customDate: false,
      schedualWeekly: '',
      schedualMonthly: '',
      DailycustomDate: '',
      dailyDate: '',
      tab: null,
      adminList: null,
      selectedFilterName: '',
      selectedCount: null,
      enabledColumns: null,
      allColumns: null,
      columnName: null,
      filterName: [],
      filterOption: [],
      report: {
        name: '',
        row: null,
        search_column: '',
        default_filter: {
          value: 'Last 30 Days',
          value1: '',
          value2: ''
        },
        report_source: '',
        columns: [],
        filters: [{
            name: '',
            key: '',
            type: '',
            lookup_expressions: '',
            options: [],
            value: '',
            value1: '',
            value2: ''
        }],
        is_scheduled: false,
        report_frequency: 'Do not repeat',
        scheduleDay: null,
        report_schedule_day: null,
        recipient_list: [],
        schedule_end: 'Never',
        schedule_end_date: '',
        trigger_day: '',
      },
      reportModel: '',
      downloadAndSaveReport: false,
      userprofileFilter: [],
      allData: null,
      reportbooleanoptions: ['true', 'false'],
      items: ['Do not repeat', 'Daily', 'Weekly', 'Monthly'],
      weeklyItem: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      monthlyItem: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
      filtersCount: 1,
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    };
  },
  beforeMount () {
    if (this.$route.name === 'EditCustomReport') {
      this.getReportData();
    }
    this.getSourceMapping();
    this.getAdmins();
    this.getFilters();
  },
  computed: {
    ...mapState({
      user: state => state.user,
    })
  },
  watch: {
    enabledColumns: {
      immediate: true,
      deep: true,
      handler () {
        this.report.columns = this.enabledColumns;
      }
    },
  },
  methods: {
    getSelectedFilterOption (name, i) {
      this.report.filters[i].value = '';

        this.$lodash.each(this.userprofileFilter, (val, k) => {
          if (val.name === name) {
            this.report.filters[i].key = val.key;
            this.report.filters[i].type = val.type;
            this.report.filters[i].options = val.filter_options;
          }
        });
    },
    getReportData () {
      axios.get(`${process.env.VUE_APP_API_URL}reports/custom_reports/${this.$route.query.report}`).then((response) => {
        if (response && response.data) {
          console.log(response.data);
          this.report.name = response.data.report_title;
          this.enabledColumns = response.data.report_columns;
          this.report.filters = response.data.report_filters[0].dataFilters;
          this.filtersCount = response.data.report_filters[0].dataFilters.length;
          this.report.report_source = response.data.report_source;
          this.report.report_frequency = response.data.report_frequency;
          this.report.recipient_list = response.data.recipient_list ? response.data.recipient_list : [];
          this.customDateShow = response.data.schedule_end_date ? true : false;
          this.radioGroup = response.data.schedule_end_date ? 1 : 0;
          this.report.schedule_end_date = response.data.schedule_end_date ? response.data.schedule_end_date.split('T')[0] : null;
          this.report.schedule_start_date = response.data.schedule_start_date ? response.data.schedule_start_date.split('T')[0] : null;
          this.report.trigger_day = response.data.trigger_day ? JSON.stringify(response.data.trigger_day) : null;
          if (response.data.trigger_day === 1 && response.data.report_frequency === 'Weekly') {
            this.report.trigger_day = 'Monday';
          }
          if (response.data.trigger_day === 2 && response.data.report_frequency === 'Weekly') {
            this.report.trigger_day = 'Tuesday';
          }
          if (response.data.trigger_day === 3 && response.data.report_frequency === 'Weekly') {
            this.report.trigger_day = 'Wednesday';
          }
          if (response.data.trigger_day === 4 && response.data.report_frequency === 'Weekly') {
            this.report.trigger_day = 'Thursday';
          }
          if (response.data.trigger_day === 5 && response.data.report_frequency === 'Weekly') {
            this.report.trigger_day = 'Friday';
          }
          if (response.data.trigger_day === 6 && response.data.report_frequency === 'Weekly') {
                this.report.trigger_day = 'Saturday';
          }
          if (response.data.trigger_day === 7 && response.data.report_frequency === 'Weekly') {
                this.report.trigger_day = 'Sunday';
          }
          this.$lodash.each(this.columnName, (val, k) => {
          if (val === this.report.report_source) {
            this.moveToColumn(this.report.report_source, k);
          }
        });
        }
      });
    },
    changeRadio (val) {
    if (val === 'never') {
        this.report.schedule_end_date = null;
        this.dailyEndnever = true;
        this.dailyEndCustom = false;
        this.customDateShow = false;
    }
    if (val === 'custom') {
        this.dailyEndCustom = true;
        this.dailyEndnever = false;
        this.customDateShow = true;
    }
    },
    getAdmins () {
      const tempList = [];
      axios.get(`${process.env.VUE_APP_API_URL}users/admins`).then((response) => {
        if (response && response.data.data && response.data.data.length > 0) {
          this.$lodash.each(response.data.data, (val) => {
            tempList.push(val.email);
          });
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to get details, Please try again later!'
          });
        }
      });
      this.adminList = tempList;
    },
    getFilters (name) {
      const tempName = [];
      const tempList = [];
      if ( name === 'Employee Chats Data') {
        axios.get(`${process.env.VUE_APP_API_URL}reports/custom_reports/get_filters/sessionmodel`).then((response) => {
            if (response && response.data) {
                this.userprofileFilter = response.data.report_data_source_mapping;
                this.$lodash.each(response.data.report_data_source_mapping, (val, k) => {
                    tempName.push(val.name);
                });
                this.filterName = tempName;
            }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to get filter, Please try again later!'
            });
          }
        });
      }
      
      if ( name === 'Employee Responses Data') {
        axios.get(`${process.env.VUE_APP_API_URL}reports/custom_reports/get_filters/sessioninteractions`).then((response) => {
            if (response && response.data) {
                this.userprofileFilter = response.data.report_data_source_mapping;
                this.$lodash.each(response.data.report_data_source_mapping, (val, k) => {
                    tempName.push(val.name);
                });
                this.filterName = tempName;
            }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to get filter, Please try again later!'
            });
          }
        });
      }
      if (name !== 'Employee Chats Data' && name !== 'Employee Responses Data') {
        axios.get(`${process.env.VUE_APP_API_URL}reports/custom_reports/get_filters/userprofile`).then((response) => {
            if (response && response.data) {
            this.userprofileFilter = response.data.report_data_source_mapping;
            this.$lodash.each(response.data.report_data_source_mapping, (val, k) => {
                tempName.push(val.name);
            });
            this.filterName = tempName;
            }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to get filter, Please try again later!'
            });
          }
        });
      }
      
    },
    
    moveToColumn (data, d) {
        this.getFilters(data)
        this.tab = 1;
        this.report.report_source = data;
        const tempColomn = [];
        const tempAllColomn = [];
        if (this.$route.name === 'EditCustomReport') {
            this.$lodash.each(this.allData[d].columns, (k, l) => {
                this.$lodash.each(this.enabledColumns, (i, j) => {
                    if (k.name === i.name) {
                        k.selected = i.selected;
                    }
                });
            });
        }
        if (data === this.allData[d].source) {
            this.$lodash.each(this.allData[d].columns, (i, j) => {
                tempAllColomn.push(i);
                if (i.selected) {
                    tempColomn.push(i);
                }
            });
        }
        this.enabledColumns = tempColomn;
        this.allColumns = tempAllColomn;
        console.log(this.enabledColumns);
        console.log(this.allData[d]);
    },
    downloadReport (id) {
      /*eslint-disable*/
      if (this.report.report_source === 'Employees Overview Data' || this.report.report_source === 'UserProfile Data') {
        this.reportModel = 'UserProfile';
        this.reportType = 'custom_employees'
      }
      if (this.report.report_source === 'Employee Responses Data') {
        this.reportModel = 'SessionInteraction';
        this.reportType = 'custom_responses'
      }
      if (this.report.report_source === 'Employee Chats Data') {
        this.reportModel = 'SessionModel';
        this.reportType = 'custom_chats'
      }
      axios.post(`${process.env.VUE_APP_API_URL}reports/custom_reports/download/?response_type=async`, {
        "report_id": id,
        "model": this.reportModel,
        "response_type":"sync",
        "report_type": this.reportType,
        "report_name": this.report.name,
        "columns": this.report.columns
      }).then((response) => {
        if (response && response.data) {
            this.$forceUpdate();
            this.socketResponse.show = true;
            this.$store.dispatch('updateReportData', this.socketResponse);
            const session = JSON.parse(localStorage.getItem('CHATBOT_USER'));
            const company = session.company.replace(/-/g, '');
            const socket = new WebSocket(`${process.env.VUE_APP_SOCKET_URL}${company}/?verify=${session.access_token}&username=${session.email}`);
            // const tempRes = null;
            socket.addEventListener('message', (res) => {
                this.socketResponse = JSON.parse(res.data);
            });
                this.$forceUpdate();
                
                setTimeout(() => {
                  this.$store.dispatch('updateReportData', this.socketResponse);
                }, 10000);
            }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.loading = false;
          this.open = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to download report, Please try again later!'
          });
        }
      });
    },
    validateDetails () {
        this.$validator.validateAll().then((res) => {
        if (res) {
          this.saveCustomReport();
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Fill all the mandatory fields!'
          });
        }
      });
    },
    validateUpdateDetails () {
        this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.report.schedule_end_date && (this.report.report_frequency === 'Daily' || this.report.report_frequency === 'Weekly' || this.report.report_frequency === 'Monthly')) {
            this.updateCustomReport();
          } else {
            this.showendDateerror = true;
          }
          if (this.report.report_frequency !== 'Daily' || this.report.report_frequency !== 'Weekly' || this.report.report_frequency !== 'Monthly') {
            this.updateCustomReport();
          }
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Fill all the mandatory fields!'
          });
        }
      });
    },
    saveAndDownload () {
        this.downloadAndSaveReport = true;
        this.validateDetails();
    },
    updateAndDownload () {
        this.downloadAndSaveReport = true;
        this.validateUpdateDetails();
    },
    updateCustomReport () {
        if (this.report.report_source === 'Employees Overview Data') {
          this.reportModel = 'UserProfile';
          this.reportType = 'custom_employees'
        }
        if (this.report.report_source === 'Employee Responses Data') {
          this.reportModel = 'SessionInteraction';
          this.reportType = 'custom_responses'
        }
        if (this.report.report_source === 'Employee Chats Data') {
          this.reportModel = 'SessionModel';
          this.reportType = 'custom_chats'
        }
        const queryParams = {};
        const tempFilter = [];
        this.$lodash.each(this.report.filters, (val, k) => {
            if (val.value.length > 0 && val.type === 'options') {
             queryParams[`${val.key}__in`] = val.value;
            }
            if (val.value.length > 0 && val.type === 'time') {
              if (val.name === 'Shift start time from' || val.name === 'Shift end time from') {
                queryParams[`${val.key}__gte`] = val.value;
              }
              if (val.name === 'Shift start time to' || val.name === 'Shift end time to') {
                queryParams[`${val.key}__lte`] = val.value;
              }
            }
            if (val.value.length > 0 && val.type === 'boolean') {
                queryParams[`${val.key}__in`] = JSON.parse(val.value);
            }
            if (val.value.length > 0 && val.type === 'date') {
              if (val.name === 'Joining date from' || val.name === 'Created from' || val.name === 'Completed from') {
                queryParams[`${val.key}__gte`] = val.value;
              }
              if (val.name === 'Joining date to' || val.name === 'Created to' || val.name === 'Completed to') {
                queryParams[`${val.key}__lte`] = val.value;
              }
            }
            tempFilter.push(queryParams);
        });
        if (this.report.trigger_day === 'Monday') {
            this.report.trigger_day = 1;
        }
        if (this.report.trigger_day === 'Tuesday') {
            this.report.trigger_day = 2;
        }
        if (this.report.trigger_day === 'Wednesday') {
            this.report.trigger_day = 3;
        }
        if (this.report.trigger_day === 'Thursday') {
            this.report.trigger_day = 4;
        }
        if (this.report.trigger_day === 'Friday') {
            this.report.trigger_day = 5;
        }
        if (this.report.trigger_day === 'Saturday') {
            this.report.trigger_day = 6;
        }
        if (this.report.trigger_day === 'Sunday') {
            this.report.trigger_day = 7;
        }
        console.log(tempFilter[0]);
        axios.patch(`${process.env.VUE_APP_API_URL}reports/custom_reports/${this.$route.query.report}/`, {
            "user": this.user.user_id,
            "report_columns": this.report.columns,
            "report_filters": [{
                dataFilters : this.report.filters
            }],
            "recipient_list": this.report.recipient_list,
            "download_filters": tempFilter[0] ? tempFilter : [],
            "report_title": this.report.name,
            "report_model": this.reportModel,
            "report_source": this.report.report_source,
            "last_report_timestamp": null,
            "next_report_timestamp": null,
            "is_scheduled": false,
            "report_frequency": this.report.report_frequency,
            "schedule_start_date": this.report.schedule_start_date ? `${this.report.schedule_start_date}T00:00:00.000Z` : null,
            "schedule_end_date": this.report.schedule_end_date ? `${this.report.schedule_end_date}T00:00:00.000Z` : null,
            "trigger_day": this.report.trigger_day ? this.report.trigger_day : null
        }).then((response) => {
          if (response && response.data) {
            if (response.data) {
              if (this.downloadAndSaveReport) {
                this.downloadReport(response.data.id);
              }
              this.editable = false;
              this.$store.dispatch('updateSnackbar', {
                color: 'success',
                show: true,
                text: 'Report saved successfully!'
              });
              this.$router.push({
                path: '/analytics/custom-report'
              }).catch(() => {});
            } else {
              this.$store.dispatch('updateSnackbar', {
                color: 'error',
                show: true,
                text: 'Unable to save report, Please try again later!'
              });
            }
            // this.templates = response.data.data;
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.loading = false;
            this.open = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to save report, Please try again later!'
            });
          }
        });
    },
    saveCustomReport () {
        if (this.report.report_source === 'Employees Overview Data') {
          this.reportModel = 'UserProfile';
          this.reportType = 'custom_employees'
        }
        if (this.report.report_source === 'Employee Responses Data') {
          this.reportModel = 'SessionInteraction';
          this.reportType = 'custom_responses'
        }
        if (this.report.report_source === 'Employee Chats Data') {
          this.reportModel = 'SessionModel';
          this.reportType = 'custom_chats'
        }
        const queryParams = {};
        const tempFilter = [];
        this.$lodash.each(this.report.filters, (val, k) => {
            if (val.value.length > 0 && val.type === 'options') {
             queryParams[`${val.key}__in`] = val.value;
            }
            if (val.value.length > 0 && val.type === 'boolean') {
                queryParams[`${val.key}__in`] = JSON.parse(val.value);
            }
            if (val.value.length > 0 && val.type === 'time') {
              if (val.name === 'Shift start time from' || val.name === 'Shift end time from') {
                queryParams[`${val.key}__gte`] = val.value;
              }
              if (val.name === 'Shift start time to' || val.name === 'Shift end time to') {
                queryParams[`${val.key}__lte`] = val.value;
              }
            }
            if (val.value.length > 0 && val.type === 'date') {
              if (val.name === 'Joining date from' || val.name === 'Created from' || val.name === 'Completed from') {
                queryParams[`${val.key}__gte`] = val.value;
              }
              if (val.name === 'Joining date to' || val.name === 'Created to' || val.name === 'Completed to') {
                queryParams[`${val.key}__lte`] = val.value;
              }
            }
          tempFilter.push(queryParams);
        });
        if (this.report.trigger_day === 'Monday') {
            this.report.trigger_day = 1;
        }
        if (this.report.trigger_day === 'Tuesday') {
            this.report.trigger_day = 2;
        }
        if (this.report.trigger_day === 'Wednesday') {
            this.report.trigger_day = 3;
        }
        if (this.report.trigger_day === 'Thursday') {
            this.report.trigger_day = 4;
        }
        if (this.report.trigger_day === 'Friday') {
            this.report.trigger_day = 5;
        }
        if (this.report.trigger_day === 'Saturday') {
            this.report.trigger_day = 6;
        }
        if (this.report.trigger_day === 'Sunday') {
            this.report.trigger_day = 7;
        }
        axios.post(`${process.env.VUE_APP_API_URL}reports/custom_reports/`, {
            "user": this.user.user_id,
            "report_columns": this.report.columns,
            "report_filters": [{
                dataFilters : this.report.filters
            }],
            "recipient_list": this.report.recipient_list,
            "download_filters": tempFilter,
            "report_title": this.report.name,
            "report_model": this.reportModel,
            "report_source": this.report.report_source,
            "last_report_timestamp": null,
            "next_report_timestamp": null,
            "is_scheduled": false,
            "report_frequency": this.report.report_frequency,
            "schedule_start_date": this.report.schedule_start_date ? `${this.report.schedule_start_date}T00:00:00.000Z` : null,
            "schedule_end_date": this.report.schedule_end_date ? `${this.report.schedule_end_date}T00:00:00.000Z` : null,
            "trigger_day": this.report.trigger_day ? this.report.trigger_day : null
        }).then((response) => {
          if (response && response.data) {
            if (response.data) {
              if (this.downloadAndSaveReport) {
                this.downloadReport(response.data.id);
              }
              this.editable = false;
              this.$store.dispatch('updateSnackbar', {
                color: 'success',
                show: true,
                text: 'Report saved successfully!'
              });
              this.$router.push({
                path: '/analytics/custom-report'
              }).catch(() => {});
            } else {
              this.$store.dispatch('updateSnackbar', {
                color: 'error',
                show: true,
                text: 'Unable to save report, Please try again later!'
              });
            }
            // this.templates = response.data.data;
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.loading = false;
            this.open = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to save report, Please try again later!'
            });
          }
        });
    },
    applyDrag (arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult;
      if (removedIndex === null && addedIndex === null) return arr;

      const result = [...arr];
      let itemToAdd = payload;

      if (removedIndex !== null) {
        itemToAdd = result[removedIndex];
        result.splice(removedIndex, 1);
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
      }

      this.$lodash.each(result, (v, k) => {
        v.index = k;
        v.enabled = true;
        v.status = 'updated';
      });
      return result;
    },
    onDrop (dropResult) {
      if (dropResult.payload) {
        dropResult.payload = JSON.parse(JSON.stringify(dropResult.payload));
      }
      console.log(dropResult);
      this.enabledColumns = this.applyDrag(this.enabledColumns, dropResult);
    },
    onDragEnd () {
      this.drag.startDragging = false;
    },
    removeFilter (index) {
      this.filtersCount -= 1;
      this.report.filters.splice(index, 1);
    },
    getSourceMapping () {
      const queryParams = {
      };
      axios.get(`${process.env.VUE_APP_API_URL}reports/custom_reports/source_mapping/`, {
        params: queryParams
      }).then((response) => {
        if (response && response.data) {
          this.allData = response.data.source_mapping;
          const tempColomn = [];
          const tempAllColomn = [];
          const tempColomnName = [];
          this.$lodash.each(this.allData, (v, k) => {
            tempColomnName.push(v.source);
          });
          this.columnName = tempColomnName;
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to get source mapping, Please try again later!'
          });
        }
      });
    },
    updateColomn (data, status, index) {
      if (status === true) {
        this.enabledColumns.push(data);
      } else {
        this.$lodash.each(this.enabledColumns, (v, k) => {
          if (v.name === data.name) {
            this.enabledColumns.splice(k, 1);
          }
        });
        
      }
        
    },
    addFilter (res, res1) {
      console.log(res);
      if (res) {
        this.optionTypeTime = false;
          this.filtersCount += 1;
          this.report.filters.push({
            name: '',
            key: '',
            type: '',
            lookup_expressions: '',
            options: [],
            value: '',
            value1: '',
            value2: ''
          });
      } else {
        this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: `Please provide value for ${res1} before adding new filter!`
          });
      }
      // if (!res1 && !res) {
      //   this.$store.dispatch('updateSnackbar', {
      //       color: 'error',
      //       show: true,
      //       text: `Please select filter then add new filter!`
      //     });
      // }
          
    }
  }
};
</script>
<style lang="scss">
.v-list-item--active:before {
  opacity: 0 !important;
} 
.greenBorder {
  border-top: 5px solid #28a745;
  padding-top: 10px;
}
.greyBorder {
  border-top: 5px solid #868e96;
  padding-top: 10px;
}
  .v-tabs-bar {
      height: auto !important;
  }
  .colomn-drag {
    .v-input--radio-group__input {
      display: -webkit-box;
    }
    .v-list {
      border-radius: 0 !important;
      padding: 0 !important;
    }
    .v-text-field__details {
      display: none !important;
    }
    .v-select__selections {
      margin: 5px;
    max-height: 82px;
    overflow-y: scroll;
      .v-chip {
        margin-top: 5px !important;
      }
    }
  }
</style>
